import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { HouseVisitSlotListRouter } from "./HouseVisitSlotListRouter";
import SlotPlanner from "./SlotPlanner";

export default {
  list: HouseVisitSlotListRouter,
  show: SlotPlanner,
  icon: CalendarMonthIcon,
  label: "Slots",
  options: { label: "Slots" },
  name: "houseVisitSlots",
};
